import { render, staticRenderFns } from "./WhyUs.vue?vue&type=template&id=fefec7f0&lang=pug&"
import script from "./WhyUs.vue?vue&type=script&lang=js&"
export * from "./WhyUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports